/* eslint-disable */
import "@babel/polyfill"

var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
import 'es5-shim';
import 'es6-shim';

import 'intersection-observer';
import 'core-js';
import 'regenerator-runtime/runtime';

const path = require('path');
import 'custom-event-polyfill';

// Poly fill for IE 11
Element.prototype._getBoundingClientRect = Element.prototype.getBoundingClientRect
Element.prototype.getBoundingClientRect = function() {
	const rect = Element.prototype._getBoundingClientRect.call(this)
	rect.x = rect.left
	rect.y = rect.top
	return rect
}


// DOMRect polyfill for IE 11.
var DOMRect = DOMRect || function(x, y, width, height) {
	this.x = this.left = x;
	this.y = this.top = y;
	this.width = width;
	this.height = height;
	this.bottom = y + height;
	this.right = x + width;
};

// My own polyfill
// https://stackoverflow.com/questions/4313841/insert-a-string-at-a-specific-index
if (!String.prototype.splice) {
	/**
	 * {JSDoc}
	 *
	 * The splice() method changes the content of a string by removing a range of
	 * characters and/or adding new characters.
	 *
	 * @this {String}
	 * @param {number} start Index at which to start changing the string.
	 * @param {number} delCount An integer indicating the number of old chars to remove.
	 * @param {string} newSubStr The String that is spliced in.
	 * @return {string} A new string with the spliced substring.
	 */
	String.prototype.splice = function(start, delCount, newSubStr) {
		return this.slice(0, start) + newSubStr + this.slice(start + Math.abs(delCount));
	};
}

// Object.values

var objectToValuesPolyfill = function(object) {
	return Object
		.keys(object)
		.map(
			function(key) {
				return object[key];
			}
		);
}

Object.values = Object.values || objectToValuesPolyfill;


window.$bus = new Vue();


// Object.entries

var objectToEntriesPolyfill = function(object) {
	return Object
		.keys(object)
		.map(
			function(key) {
				return [key, object[key]];
			}
		);
}

Object.entries = Object.entries || objectToEntriesPolyfill;

// smoothscroll polyfill for IE 11
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
var hideIE11 = false;
if (isIE11) {
	hideIE11 = true;
}
import VueCurrencyInput from 'vue-currency-input'
Vue.use(VueCurrencyInput)

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
Vue.component('VueSlider', VueSlider)


import VueTooltip from 'v-tooltip'
Vue.use(VueTooltip);
VueTooltip.options.defaultTemplate = '<div class="EduTaxRebateWidgetGovMB__tooltip-vue" role="EduTaxRebateWidgetGovMB__tooltip"><div class="EduTaxRebateWidgetGovMB__tooltip-vue-arrow"></div><div class="EduTaxRebateWidgetGovMB__tooltip-vue-inner"></div></div>';
VueTooltip.options.defaultArrowSelector = '.EduTaxRebateWidgetGovMB__tooltip-vue-arrow, .EduTaxRebateWidgetGovMB__tooltip-vue__arrow';
VueTooltip.options.defaultInnerSelector = '.EduTaxRebateWidgetGovMB__tooltip-vue-inner, .EduTaxRebateWidgetGovMB__tooltip-vue__inner';
VueTooltip.options.defaultTrigger = window.innerWidth > 768 ? 'hover click' : 'click';


// plugins

import axios from 'axios'
Vue.prototype.$http = axios.create();
Vue.prototype.$http.defaults.baseURL = process.env.VUE_APP_API_URL // same as the Url the server listens to
Vue.prototype.$http.defaults.withCredentials = true

Vue.prototype.$httpNoCORS = axios.create();
Vue.prototype.$httpNoCORS.withCredentials = false;
Vue.prototype.$httpNoCORS.baseURL = "";
delete Vue.prototype.$httpNoCORS.defaults.headers.common['Authorization'];

// widget setup
// (optional) 'Custom elements polyfill'
import 'document-register-element/build/document-register-element'
// vue-custom-element by karol-f
import vueCustomElement from 'vue-custom-element'
Vue.use(vueCustomElement)


import HorizontalScroll from 'vue-horizontal-scroll'


import numeral from 'numeral'
numeral.register('locale', 'fr', {
	delimiters: {
		thousands: ' ',
		decimal: '.'
	},
	abbreviations: {
		thousand: 'k',
		million: 'm',
		billion: 'b',
		trillion: 't'
	},
	ordinal: function(number) {
		return number === 1 ? 'er' : 'ème'
	},
	currency: {
		symbol: '$'
	}
})

numeral.defaultFormat('0,0');

Vue.filter('formatNumber', function(value) {
	return numeral(value).format('0,0')
		// displaying other groupings/separators is possible, look at the docs
})

import Vue2Filters from 'vue2-filters';
Vue.use(Vue2Filters);


import VueI18n from 'vue-i18n';
import messages from './translations/common.js';

Vue.use(VueI18n);

const i18n = new VueI18n({
	locale: localStorage.locale || 'en-CA',
	fallbackLocale: 'en-CA',
	fallbackRoot: true,
	silentTranslationWarn: true,
	messages
});




const moment = require('moment');
// require('moment/locale/fr-ca');
// Need to use the 8859-1 conversion to get the last updated date to output correctly.
require('./translations/moment/locale/fr-88591');
require('moment/locale/en-ca');
moment.relativeTimeThreshold('s', 59);
moment.relativeTimeThreshold('m', 59);
moment.relativeTimeThreshold('h', 23);
Vue.use(require('vue-moment'), {
	moment
})

import Vuex from 'vuex';
Vue.use(Vuex);
// Sets focus on an element when it gets inserted into the DOM.
Vue.directive('focus', {
	inserted(el) {
		el.focus();
	}
});
Vue.config.productionTip = false

// new Vue is not needed anymore, as you're initializing the app through vue-custom-element
// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')

// use vue-custom-element
App.store = store
App.router = router
App.i18n = i18n
const $root = Vue.customElement('calculator-edu-prop-tax-rebate', App, {
	shadow: false,
	beforeCreateVueInstance(root) {
		const rootNode = root.el.getRootNode();

		if (rootNode instanceof ShadowRoot) {
			root.shadowRoot = rootNode;
		} else {
			root.shadowRoot = document.head;
		}
		return root;
	},
})